import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Button,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  ButtonBase,
} from "@mui/material";
import BeenhereOutlinedIcon from "@mui/icons-material/BeenhereOutlined";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ExploreIcon from "@mui/icons-material/Explore";

import BookingIcon from "../../components/icons/BookingIcon";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import PersonIcon from "@mui/icons-material/Person";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ user, logOut, mobile, handleLogout, locationChanged }) => {
  const [value, setValue] = useState(1);
  const [selectedTab, setSelectedTab] = useState(0);
  const [appBarHeight, setAppBarHeight] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    loadSelectedTab();
  }, []);

  const loadSelectedTab = () => {
    const location = window.location.pathname;
    //console.log("Location: ", location);
    if (location.includes("reservar") || location.includes("gimnasio")) {
      setValue(1);
    } else if (location.includes("perfil")) {
      setValue(2);
    } else if (location.includes("explorar")) {
      setValue(0);
    } else if (location != "/") {
      setValue(2);
    }
    const appBarElement = document.getElementById("TopNavBar");
    if (appBarElement) {
      const height = appBarElement.clientHeight;
      setAppBarHeight(appBarElement);
    }
  };

  useEffect(() => {
    loadSelectedTab();
  }, [locationChanged]);

  useEffect(() => {
    loadSelectedTab();
  }, [window.location.pathname]);

  return (
    <>
      {mobile ? (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            backgroundColor: "#282B33",
            height: "70px",
            //borderRadius: "20px 20px 0px 0px",
            backgroundColor: "rgba(40, 43, 51, 0.7)", // Fondo semitransparente
            backdropFilter: "blur(10px)",
          }}
          elevation={3}
          zIndex={1000}
        >
          <ButtonBase
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "33%",
              gap: "5px",
              color: value == 0 ? "#FF9700" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={() => {
              setValue(0);
              navigate("/explorar");
            }}
          >
            {value == 0 ? <ExploreIcon /> : <ExploreOutlinedIcon />}
            <Typography
              style={{
                borderRadius: "10px",
                fontSize: "16px",
                fontFamily: "Urbanist",
                fontWeight: "400",

                textAlign: "center",
              }}
            >
              Gimnasios
            </Typography>
          </ButtonBase>
          <ButtonBase
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "33%",
              gap: "5px",
              color: value == 1 ? "#FF9700" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={() => {
              setValue(1);
              navigate("/reservar");
            }}
          >
            {value == 1 ? <AddBoxIcon /> : <AddBoxOutlinedIcon />}
            <Typography
              style={{
                borderRadius: "10px",
                fontSize: "16px",
                fontFamily: "Urbanist",
                fontWeight: "400",
                textAlign: "center",
              }}
            >
              Reservar
            </Typography>
          </ButtonBase>
          <ButtonBase
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "33%",
              gap: "5px",
              color: value == 2 ? "#FF9700" : "rgba(255, 255, 255, 0.7)",
            }}
            onClick={() => {
              setValue(2);
              navigate("/perfil");
            }}
          >
            {value == 2 ? <PersonIcon /> : <PersonOutlineOutlinedIcon />}
            <Typography
              style={{
                borderRadius: "10px",
                fontSize: "16px",
                fontFamily: "Urbanist",
                fontWeight: "400",
                textAlign: "center",
              }}
            >
              Perfil
            </Typography>
          </ButtonBase>
        </Box>
      ) : (
        <AppBar position="sticky" style={{ background: "#1F222A" }} elevation={0}>
          <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Box
                onClick={() => {
                  setValue(1);
                  navigate("/reservar");
                }}
              >
                <img
                  src="/img/icon.png"
                  alt="Logo"
                  style={{
                    marginLeft: "20px",
                    marginRight: "10px",
                    cursor: "pointer",
                    height: 40,
                  }}
                />
              </Box>
              <Box style={{ display: "flex", gap: 15, marginLeft: 20 }}>
                <Typography
                  style={styles.tab}
                  onClick={() => {
                    setValue(1);
                    navigate("/reservar");
                  }}
                  fontWeight={value == 1 ? 600 : 200}
                >
                  Reservar
                </Typography>

                <>
                  <Typography
                    style={styles.tab}
                    onClick={() => {
                      setValue(0);
                      navigate("/explorar");
                    }}
                    fontWeight={value == 0 ? 600 : 200}
                  >
                    Gimnasios
                  </Typography>
                  <Typography
                    style={styles.tab}
                    onClick={() => {
                      setValue(2);
                      navigate("/perfil");
                    }}
                    fontWeight={value == 2 ? 600 : 200}
                  >
                    Perfil
                  </Typography>
                </>
              </Box>
            </div>
            <Typography
              style={{ ...styles.tab, marginLeft: "auto" }}
              onClick={handleLogout}
              fontWeight={selectedTab == 3 ? 600 : 200}
            >
              Cerrar sesión
            </Typography>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

const styles = {
  tab: {
    cursor: "pointer",
    fontSize: 18,
  },
};

export default Navbar;
